import { z } from "zod";
export const ApplicationCRMMetadataSchema = z.object({}).passthrough().partial();
